import React from "react";
import { useTranslation } from "react-i18next";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import Footer from "../Shared/Footer";
import MetaTags from "../Shared/MetaTags";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full min-h-screen flex flex-col">
      <MetaTags
        title={t("contact.helmet.title")}
        description={t("contact.helmet.desc")}
      />

      <section className="px-4 w-full flex-1 overflow-hidden bg-gradient-to-b from-[#F7DFDF33] to-[#FFFFFF00] relative py-16">
        <img
          src="/assets/zones/map_bg.svg"
          className="object-cover absolute top-0 -right-12 w-1/2 z-0"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 mx-auto w-full max-w-6xl gap-x-4 gap-y-12 z-[1] relative">
          <LeftSection />
          <RightSection />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
